import 'assets/css/HAGD-Custom.css';
import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
// react plugin for creating notifications over the dashboard
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import DNS from 'components/DNS/dns.js';
// import HAGDIMG from './HaveAGoodDay.png'
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import {isMobile, isTablet} from 'react-device-detect';
import {
  Button,
  Card,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import Moment from 'react-moment';
import {CardFooter} from 'reactstrap';
import DNSO from 'components/DNS/dns-offline';
import ModalViewEvent from './modalVIEW';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
/**
 * This function handle all the event and style in the event sport page.
 * @function EventSport
 * @param {props} props props.
 * @return {HTML} the event sport's page.
 */
function EventSport(props) {
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const token = useSelector((state) => state.token);
  const User = useSelector((state) => state.user);
  const [showDescription, setDescription] = useState('');
  const [showEventname, setEventname] = useState('');
  const [showOrganizer, setOrganizer] = useState('');
  const [showPrice, setPrice] = useState(0);
  const [showImage, setImage] = useState('');
  const [showFloors, setFloors] = useState('');
  const [showRooms, setRooms] = useState('');
  const [showUsermax, setUsermax] = useState('');
  const [showUserpresent, setUserpresent] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showEventStartDate, setEventStartDate] = useState('');
  const [showEventStartTime, setEventStartTime] = useState('');
  const [showEventEndDate, setEventEndDate] = useState('');
  const [showEventEndTime, setEventEndTime] = useState('');
  const [showEventPk, setEventPk] = useState('');
  const [showUserNb, setUserNb] = useState('');
  const [showUserRegisterList, setUserRegisterList] = useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [showStartWeekDate, setStartWeekDate] = useState(new Date().toISOString().slice(0, 10));
  const [showEndWeekDate, setEndWeekDate] = useState(new Date().toISOString().slice(0, 10));
  const calendarRef = React.createRef(FullCalendar);
  const [aevent, setEvent] = useState({
    data: null,
    error: false,
  }, []);

  const [page, setPage] = React.useState(0);
  const {t} = useTranslation();


  useEffect(() => {
    let start = showStartWeekDate;
    let end = showEndWeekDate;
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      const type = moment(calendarApi.getDate());
      start = type.startOf('month').format('YYYY-MM-DD');
      end = type.endOf('month').format('YYYY-MM-DD');
      setStartWeekDate(start);
      setEndWeekDate(end);
      getEvent(start, end);
    } else {
      getEventNo();
    }
    const search = props.location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    setPage(params.get('page') ? params.get('page') - 1 : 0);
  }, []);

  const requestOptions = {
    method: 'GET',
    headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
  };

  const getEvent = (start=showStartWeekDate, end=showEndWeekDate) => {
    fetch(DNS + '/event/deleteGetPatchEvent/' + currentBuilding['currentbuildingRedux'].pk + '/?eventType=Salle de Sport&start='+start+'&end='+end, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          if (data.fields) {
            setEvent({
              data: data.fields,
              error: false,
            });
            return;
          } else {
            setEvent({
              data: data.fields,
              error: false,
            });
            return;
          }
        })
        .catch((err) => console.log(err));
  };

  const getEventNo = () => {
    fetch(DNS + '/event/deleteGetPatchEvent/' + currentBuilding['currentbuildingRedux'].pk + '/?eventType=Salle de Sport', requestOptions)
        .then(async (response) => {
          const data = await response.json();
          if (data.fields) {
            setEvent({
              data: data.fields,
              error: false,
            });
            return;
          } else {
            setEvent({
              data: data.fields,
              error: false,
            });
            return;
          }
        })
        .catch((err) => console.log(err));
  };

  const handleDateClick = (arg) => {
    setEventname(arg.event.extendedProps.Etitle);
    setImage(arg.event.extendedProps.Eimage);
    setDescription(arg.event.extendedProps.description);
    setEventStartDate(arg.event.extendedProps.EdebutDate);
    setEventStartTime(arg.event.extendedProps.EdebutTime);
    setEventEndDate(arg.event.extendedProps.EendDate);
    setEventEndTime(arg.event.extendedProps.EendTime);
    setOrganizer(arg.event.extendedProps.organize);
    setFloors(arg.event.extendedProps.floors);
    setRooms(arg.event.extendedProps.rooms);
    setUserpresent(arg.event.extendedProps.userNb);
    setUsermax(arg.event.extendedProps.maxUserNB);
    setEventPk(arg.event.extendedProps.Eventvpk);
    setUserNb(arg.event.extendedProps.userNb);
    setUserRegisterList(arg.event.extendedProps.userRegistered);
    setPrice(arg.event.extendedProps.Price);
    setShowModal(true);
  };

  const renderEventContent = (arg) => {
    const Hour = arg.event.extendedProps.EdebutTime.split(':');
    const prettyHourBegin = Hour[0] + ':' + Hour[1];

    const Hour2 = arg.event.extendedProps.EendTime.split(':');
    const prettyHourEnd = Hour2[0] + ':' + Hour2[1];

    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundImage: `url(${arg.event.extendedProps.Eimage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255, 211, 59, 0.25)',
            overflow: 'hidden',
            height: '100%',
            width: '100%',
          }}
        >
          <>
            <p style={{overflow: 'hidden', fontSize: '13px'}}> {prettyHourBegin + ' - ' + prettyHourEnd}</p>
          </>
          <>
            <p style={{textAlign: 'center', fontWeight: 'bold', overflow: 'hidden', color: 'black'}}> {arg.event.title}</p>
          </>
        </div>
      </div>
    );
  };


  const checkIfRegister = (RegisterList, UserPk) => {
    let status = false;
    RegisterList.map((pkuser, key) => {
      if (pkuser.id == UserPk) {
        status = true;
      }
    });
    if (status == true) {
      return true;
    } else {
      return false;
    }
  };

  let calendardata = null;
  if (aevent.data) {
    calendardata =
    aevent.data.slice(0).reverse().filter((val) => {
      if (searchTerm == '') {
        return val;
      } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return val;
      } else if (val.description.toLowerCase().includes(searchTerm.toLowerCase())) {
        return val;
      }
    }).map((event, key) => {
      const calendardata2 = {
        title: event.name,
        start: event.eventDateBegin + 'T' + event.eventTimeBegin,
        end: event.eventDateEnd + 'T' + event.eventTimeEnd,
        color: 'light-blue',
        extendedProps: {
          description: event.description,
          Eventvpk: event.pk,
          organize: event.organize,
          EnbUserExpected: event.UserNb,
          Etitle: event.name,
          floors: event.floors,
          rooms: event.room,
          userNb: event.userNb,
          pkUser: event.pkUser,
          maxUserNB: event.maxUserNB,
          userRegistered: event.userRegistered,
          EdebutDate: event.eventDateBegin,
          EdebutTime: event.eventTimeBegin,
          EendDate: event.eventDateEnd,
          EendTime: event.eventTimeEnd,
          Eicon: event.icon,
          Eimage: event.image,
          Price: event.price,
          CurrEvent: event,
        },
      };
      return calendardata2;
    });
  }

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card id="PDF-Table">
            <Card.Header>
              {!isMobile || isTablet ?
                <Card.Title as="h4" >{t(translations.EVENT_SUBTITLE4)}</Card.Title> :
                <Card.Title as="h4" className={'text-center'}>{t(translations.EVENT_SUBTITLE4)}</Card.Title>
              }
              <p className="card-category">
                <br/>
              </p>
              <div className="row pl-0 pr-0" style={{paddingTop: '15px'}}>
                <div id="custom-search-input">
                  <div className="input-group col-md-12 pl-0 pr-0">
                    <input type="text" className="form-control ml-1"
                      placeholder={t(translations.SEARCH)}
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}
                    />
                    <span className="input-group-btn btn btn-primary">
                      <span className=" fas fa-search"></span>
                    </span>
                  </div>
                </div>
              </div>
            </Card.Header>
            <Card.Body className={'p-0 mt-0'}>
              <div style={{width: '100%', backgroundColor: 'black'}}>
                {
                  !isMobile || isTablet ?
                <FullCalendar
                  ref={calendarRef}
                  nextDayThreshold={'00:00:00'}
                  plugins={[dayGridPlugin]}
                  slotEventOverlap={true}
                  height={500}
                  eventMaxStack={3}
                  initialView={'dayGridMonth'}
                  headerToolbar={{
                    left: 'prev,next',
                    center: 'title',
                    right: isMobile ? 'dayGridDay' : 'dayGridMonth',
                  }}
                  buttonText={{
                    month: t(translations.MONTH),
                    week: t(translations.WEEK),
                    day: t(translations.DAY),
                    list: t(translations.LIST),
                  }}
                  customButtons={{
                    next: {
                      click: () => {
                        const calendarApi = calendarRef.current.getApi();
                        calendarApi.next();
                        const type = moment(calendarApi.getDate());
                        const date2 = moment(showEndWeekDate);
                        if (type > date2) {
                          const start = type.startOf('month').format('YYYY-MM-DD');
                          const end = type.endOf('month').format('YYYY-MM-DD');
                          setStartWeekDate(start);
                          setEndWeekDate(end);
                          getEvent(start, end);
                        }
                      },
                    },
                    prev: {
                      click: () => {
                        const calendarApi = calendarRef.current.getApi();
                        calendarApi.prev();
                        const type = moment(calendarApi.getDate());
                        const date2 = moment(showStartWeekDate);
                        if (type < date2) {
                          const start = type.startOf('month').format('YYYY-MM-DD');
                          const end = type.endOf('month').format('YYYY-MM-DD');
                          setStartWeekDate(start);
                          setEndWeekDate(end);
                          getEvent(start, end);
                        }
                      },
                    },
                  }}
                  locale={localStorage.i18nextLng == 'fr' ? 'fr' : 'en'}
                  firstDay={1}
                  allDaySlot={false}
                  eventClick={handleDateClick}
                  events={calendardata}
                  eventContent={renderEventContent}
                /> :
                <>
                  {aevent.data && aevent.data.slice(0).reverse().slice(page * 10, page * 10 + 10).map((event, key)=> {
                    return (
                      <div className="card" id='pk' value={event.pk} key={key} onClick={() => {
                        setEventname(event.name);
                        setImage(event.image);
                        setDescription(event.description);
                        setEventStartDate(event.eventDateBegin);
                        setEventStartTime(event.eventTimeBegin);
                        setEventEndDate(event.eventDateEnd);
                        setEventEndTime(event.eventTimeEnd);
                        setOrganizer(event.organize);
                        setFloors(event.floors);
                        setRooms(event.room);
                        setUserpresent(event.userNb);
                        setUsermax(event.maxUserNB);
                        setEventPk(event.pk);
                        setUserNb(event.userNb);
                        setUserRegisterList(event.userRegistered);
                        setPrice(event.price);

                        setShowModal(true);
                      }}>
                        <div className="row justify-content-start px-3">
                          <div className="image-bg mr-3"><img className="user-img fit-image"
                            src={event.image}/></div>
                          <div className="offset-4 position-absolute">
                            <h2 className={'nameAppointment'}>{event.name}</h2>
                            <h6 className={'dateAppointment'}><i className="fa fa-calendar" aria-hidden="true"></i>{t(translations.BEGINNING) + ' : ' }<Moment format="DD/MM/YYYY">{event.eventDateBegin}</Moment> à {event.eventTimeBegin.substring(0, event.eventTimeBegin.length-3)}</h6>
                            <h6 className={'dateAppointment'}><i className="fa fa-calendar-check" aria-hidden="true"></i>{t(translations.ENDING) + ' : ' }<Moment format="DD/MM/YYYY">{event.eventDateEnd}</Moment> à {event.eventTimeEnd.substring(0, event.eventTimeEnd.length-3)}</h6>
                            <h6 className={'dateAppointment'}><i className="fa fa-info-circle"></i>{ showPrice != 0 ?
                                      <span className="badge badge-success">
                                        {showPrice}€
                                      </span> :
                                      <span className="badge badge-success">
                                        {t(translations.FREE)}
                                      </span>
                            } </h6>
                            { new Date(event.eventDateEnd.replace(/-/g, '/') + ' ' + event.eventTimeEnd).getTime() >= new Date().getTime() ?
                                      <div> {
                                        checkIfRegister(event.userRegistered, User.user['pk']) == false ?
                                            <Button className={'btn  btn-yellow '} onClick={() => {
                                              setEventname(event.name);
                                              setImage(event.image);
                                              setDescription(event.description);
                                              setEventStartDate(event.eventDateBegin);
                                              setEventStartTime(event.eventTimeBegin);
                                              setEventEndDate(event.eventDateEnd);
                                              setEventEndTime(event.eventTimeEnd);
                                              setOrganizer(event.organize);
                                              setFloors(event.floors);
                                              setRooms(event.room);
                                              setUserpresent(event.userNb);
                                              setUsermax(event.maxUserNB);
                                              setUserNb(event.userNb);
                                              setUserRegisterList(event.userRegistered);
                                              setPrice(event.price);

                                              setShowModal(true);
                                            }}>{t(translations.REGISTER)}</Button> :
                                            <Button className={'btn btn-yellow'} onClick={() => {
                                              setEventname(event.name);
                                              setImage(event.image);
                                              setDescription(event.description);
                                              setEventStartDate(event.eventDateBegin);
                                              setEventStartTime(event.eventTimeBegin);
                                              setEventEndDate(event.eventDateEnd);
                                              setEventEndTime(event.eventTimeEnd);
                                              setOrganizer(event.organize);
                                              setFloors(event.floors);
                                              setRooms(event.room);
                                              setUserpresent(event.userNb);
                                              setUsermax(event.maxUserNB);
                                              setUserNb(event.userNb);
                                              setUserRegisterList(event.userRegistered);
                                              setPrice(event.price);
                                              setShowModal(true);
                                            }}>{t(translations.UNREGISTER)}</Button>
                                      }</div> :
                                      null
                            }
                          </div>
                        </div>
                        <div className="line"></div>
                      </div>
                    );
                  },
                  )
                  }
                </>
                }
                <ModalViewEvent showModal={showModal} setShowModal={setShowModal} showImage={showImage} showEventname={showEventname} showOrganizer={showOrganizer} showEventStartDate={showEventStartDate} showEventStartTime={showEventStartTime} showEventEndDate={showEventEndDate} showEventEndTime={showEventEndTime} showFloors={showFloors} showRooms={showRooms} showUserpresent={showUserpresent} showUsermax={showUsermax} showPrice={showPrice} showDescription={showDescription} showUserRegisterList={showUserRegisterList} showUserPk={User.user['pk']} showUserNb={showUserNb} showEventPk={showEventPk} checkIfRegister={checkIfRegister} getEvent={calendarRef.current ? getEvent : getEventNo} />
              </div>


            </Card.Body>
            { aevent.data ?
              isMobile && !isTablet ?
                  <CardFooter className="text-center m-auto">
                    <ul className="pagination">
                      <li className="page-item" onClick={() => {
                        if (page > 0) {
                          window.location.replace(DNSO + '/resident/Events?page=' + page);
                        }
                      }}>
                        <a className="page-link" href="#">«</a>
                      </li>
                      {

                        aevent.data ? aevent.data.length / 10 <= 3 ? new Array(Math.ceil(aevent.data.length / 10)).fill(0).map((item, index) => {
                          return (
                            <li key={index} className={'page-item' + (page == index ? ' active' : '')} onClick={() => {
                              window.location.replace(DNSO + '/resident/Events?page=' + (index + 1));
                            }}>
                              <a className="page-link " href="#">{index+1}</a>
                            </li>
                          );
                        }) :
                            <>
                              <li style={{display: page != 0 ? 'flex' : 'none'}} className={'page-item'} onClick={() => {
                                window.location.replace(DNSO + '/resident/Events?page=' + (page));
                              }}>
                                <a className="page-link " href="#">{page}</a>
                              </li>
                              <li className={'page-item active'} onClick={() => {
                                window.location.replace(DNSO + '/resident/Events?page=' + (page + 1));
                              }}>
                                <a className="page-link " href="#">{page + 1}</a>
                              </li>
                              <li style={{display: page + 2 <= aevent.data.length / 10 ? 'flex' : 'none'}} className={'page-item'} onClick={() => {
                                window.location.replace(DNSO + '/resident/Events?page=' + (page + 2));
                              }}>
                                <a className="page-link " href="#">{page+2}</a>
                              </li>
                              <li style={{display: page + 1 !== Math.ceil(aevent.data.length / 10) ? 'flex' : 'none'}} className={'page-item'} onClick={() => {
                                window.location.replace(DNSO + '/resident/Events?page=' + Math.ceil(aevent.data.length / 10));
                              }}>
                                <a className="page-link " href="#">{Math.ceil(aevent.data.length / 10)}</a>
                              </li>
                            </> : null
                      }

                      <li className="page-item" onClick={() => {
                        if (page + 1 !== Math.ceil(aevent.data.length / 10)) {
                          window.location.replace(DNSO + '/resident/Events?page=' + (page + 2));
                        }
                      }}>
                        <a className="page-link" href="#">»</a>
                      </li>
                    </ul>
                  </CardFooter> :
                  <CardFooter className="text-center m-auto">
                  </CardFooter> :
              isMobile && !isTablet ?
                  <CardFooter className="text-center m-auto">
                    <h4 className={'dateAppointment'}>
                      <i className="fa fa-calendar" aria-hidden="true"></i>
                    </h4>
                    <h5 style={{fontStyle: 'CeraPro', color: 'white'}}>{t(translations.EVENT_SUBTITLE3)}</h5>
                  </CardFooter> :
                  <CardFooter className="text-center m-auto">
                  </CardFooter>
            }
          </Card >

        </Col>
      </Row>
    </Container>
  );
}

export default EventSport;
